export const INPUT_NUMBER_REGEX = /^[1-9]\d*\.\d{0,18}$|^0\.\d{0,18}$|^[0-9\b]+$/;
